import { useState } from "react";
import { Button } from "antd";
import { ResultModal } from "../mythPASSModal";
import { Web3Store } from "../../stores/web3Store";
import logger from "../../logger";
import { INft } from "../../bean/OpenseaBean";
import { ILicenseCollectionRequest, ILicenseNFT, ILicenseNFTsRequest } from "../../bean/RequestBean";
import { MythServerResultCode } from "../../constant/CommonConstant";

interface IProps {
    disabled: boolean,
    selectedNFTs: INFTItem[],
    web3Store: Web3Store
}

export interface INFTItem {
    nft: INft,
    licensed: boolean,
    collectionId: number
}

export const LicenseButton = ({ disabled, selectedNFTs, web3Store }: IProps) => {
    const [params, setVisible] = useState({ visible: false, success: false, content: '' });
    const [loading, setLoading] = useState(false);

    const licenseNFTs = async () => {
        if (web3Store.mythServerApi && web3Store.account && selectedNFTs && selectedNFTs.length > 0) {
            setLoading(true)
            const licenseCollections: ILicenseCollectionRequest[] = [];

            selectedNFTs.forEach(item => {
                const nft = item.nft;
                const collection = licenseCollections.find(value => {
                    return value.collectionAddr === nft.tokenAddress;
                });
                const nftItem: ILicenseNFT = {
                    tokenId: nft.tokenId,
                    name: nft.nftName ? nft.nftName : '',
                    image: nft.image ? nft.image : ''
                };
                if (collection) {
                    collection.nfts.push(nftItem);
                } else {
                    const nfts: ILicenseNFT[] = [];
                    nfts.push(nftItem);
                    licenseCollections.push({
                        collectionAddr: nft.tokenAddress,
                        collectionId: item.collectionId,
                        nfts: nfts
                    });
                }
            });

            const params: ILicenseNFTsRequest = {
                licenseCollections: licenseCollections,
                signature: ""
            };

            try {
                const result = await web3Store.mythServerApi.licenseNFTs(web3Store.account, params);
                if (result.resultCode === MythServerResultCode.SUCCESS && result.resultValue) {
                    const content = `${selectedNFTs.length} NFTs have been licensed to SuperBrands platform.`;
                    setVisible({ visible: true, success: true, content: content });
                }

                setLoading(false);
            } catch (e) {
                logger.error(e);
                setVisible({ visible: true, success: false, content: '' });
                setLoading(false)
            }
        }
    };

    const btn = <><Button onClick={() => {
        window.location.reload()
    }}>Ok</Button></>

    return <>
        <Button className="myth-button btn-authorize" loading={loading} onClick={licenseNFTs}
            disabled={disabled}>License</Button>
        {params.visible &&
            <ResultModal visible={params.visible} success={params.success} content={btn} text={params.content}
                title="License NFT Result" onCancel={() => {
                    setVisible({ visible: false, success: false, content: '' });
                }} />}
    </>
}
